/** @jsx jsx */
import { Children } from 'react';
import { css, jsx } from '@emotion/react';
var gutter = "var(--ds-space-negative-050, -4px)";
var listStyles = css({
  // removes default ul styles. Needs !important to override contextual styles in product.
  display: 'flex',
  margin: "var(--ds-space-0, 0px)",
  marginRight: gutter,
  marginLeft: gutter,
  padding: "var(--ds-space-0, 0px)",
  justifyContent: 'flex-start',
  flexWrap: 'wrap',
  lineHeight: 1,
  listStyleType: 'none !important'
});
var listItemStyles = css({
  margin: "var(--ds-space-0, 0px)",
  marginBottom: "var(--ds-space-100, 8px)",
  paddingRight: "var(--ds-space-050, 4px)",
  paddingLeft: "var(--ds-space-050, 4px)"
});
var Grid = function Grid(_ref) {
  var children = _ref.children,
    testId = _ref.testId,
    label = _ref['aria-label'];
  return jsx("ul", {
    "data-testid": testId,
    "aria-label": label,
    css: listStyles
  }, Children.map(children, function (child) {
    return child && jsx("li", {
      css: listItemStyles
    }, child);
  }));
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default Grid;